export const COUPONS_GROUPS = {
  custom: 'custom',
  mixed: 'mixed',
  newest: 'newest',
  popular: 'popular',
  mixedForRetailer: 'mixedForRetailer',
};
